import React, { useEffect, useState } from 'react';
import clienteAxios from '../../../../config/clientAxios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement, } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import Cargando from '../../../extras/Cargando';
import { Tabs, Tab } from 'react-bootstrap';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement);

const Vuelos = () => {
    const [statusTotal, setStatusTotal] = useState(undefined);
    const [statusTipo, setStatusTipo] = useState(undefined);
    const [total, setTotal] = useState({ "datasets": [], "labels": [] });
    const [tipo, setTipo] = useState({ "datasets": [], "labels": [] });
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            }
        }
    };
    const [key, setKey] = useState('total');
    useEffect(() => {
        const getTotal = async () => {
            await clienteAxios.get(`cieg/turismo/vuelos/total`, { timeout: 30000 })
                .then(response => {
                    setStatusTotal(true);
                    setTotal(response.data.datasets);
                }).catch(error => {
                    setStatusTotal(false);
                    console.error(error);
                });
        }
        const getTon = async () => {
            await clienteAxios.get(`cieg/turismo/vuelos/tipo`, { timeout: 30000 })
                .then(response => {
                    setStatusTipo(true);
                    setTipo(response.data.datasets);
                }).catch(error => {
                    setTipo(false);
                    console.error(error);
                });
        }
        getTotal();
        getTon();
    }, []);
    return (
        <div className='container'>
            <Tabs
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3">
                <Tab eventKey="total" title="Total">
                    <div className='row justify-content-md-center'>
                        {statusTotal === true ? <Bar data={total} options={options} /> : <Cargando />}
                    </div>
                </Tab>
                <Tab eventKey="tipo" title="Tipo Vuelo">
                    <div className='row justify-content-md-center'>
                        {statusTipo === true ? <Bar data={tipo} options={options} /> : <Cargando />}
                    </div>
                </Tab>
            </Tabs>
            <div className='row'>
                <div className='col-lg-8' style={{ textAlign: 'left', fontSize: '12px' }}>
                    <p><strong>Fuente: </strong><i>{"Aeropuertos y Servicios Auxiliares. Secretaría de Comunicaciones y Transportes"}</i></p>
                </div>
                <div className='col-lg-8' style={{ textAlign: 'left', fontSize: '12px' }}>
                    <p><strong>Nota: </strong><i>{"Para el año 2022 Cifras preliminares, sujetas a cambio por los propios aeropuertos."}</i></p>
                    <br/>
                    <i>{"Para el año 2023 los datos son al mes de junio, sujetas a cambio por los propios aeropuertos."}</i>
                </div>
            </div>
        </div>
    );
}
export default Vuelos;